// is this really better than normal case? Have to-remap in components for TS
export enum SsbMutations {
  RESET = "RESET",
  SET_SSB_CODES = "SET_SSB_CODES",
  SET_COUNTRIES = "SET_COUNTRIES",
}
